var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    This field is using Mustache syntax so you can use placeholders as fields from your component settings. "),_c('br'),_c('br'),_vm._v(" ex: "),_c('code',{pre:true},[_vm._v("Hi {{firstname}}, how are you today?")])])
}]

export { render, staticRenderFns }